import {useQuery} from "@tanstack/react-query"

import api, {queryKey} from "../services"
import {useUserSettingsOrLogout} from "./user.ts"

export const useCompanyDashboardQuery = () => {
  const {user} = useUserSettingsOrLogout()

  return useQuery({
    queryKey: queryKey.companyDashboard(user.id),
    queryFn: async () => (await api.companyUsers.dashboardDetail(user.id)).data.dashboard,
    staleTime: 0,
  })
}

export const useCompanyDashboardActiveSalesCyclesQuery = () => {
  const {user} = useUserSettingsOrLogout()

  return useQuery({
    queryKey: queryKey.companyDashboardActive(user.id),
    queryFn: async () => (await api.companyUsers.dashboardActiveSalesCyclesList(user.id)).data.sales_cycles,
    staleTime: 0,
  })
}
export const useCompanyDashboardDraftSalesCyclesQuery = () => {
  const {user} = useUserSettingsOrLogout()

  return useQuery({
    queryKey: queryKey.companyDashboardDraft(user.id),
    queryFn: async () => (await api.companyUsers.dashboardDraftedSalesCyclesList(user.id)).data.sales_cycles,
    staleTime: 0,
  })
}
export const useCompanyDashboardFinishedSalesCyclesQuery = () => {
  const {user} = useUserSettingsOrLogout()

  return useQuery({
    queryKey: queryKey.companyDashboardFinished(user.id),
    queryFn: async () => (await api.companyUsers.dashboardFinishedSalesCyclesList(user.id)).data.sales_cycles,
    staleTime: 0,
  })
}

export const useCompanyDashboardPausedCyclesQuery = () => {
  const {user} = useUserSettingsOrLogout()

  return useQuery({
    queryKey: queryKey.companyDashboardPaused(user.id),
    queryFn: async () => (await api.companyUsers.dashboardPausedSalesCyclesList(user.id)).data.sales_cycles,
    staleTime: 0,
  })
}
